import React, { useEffect, useState, useRef } from "react";
import axiosClient from "../api/axiosClient";
import { useNavigate, useParams } from "react-router-dom";
import styles from "../script/reviewStyles";

export default function ReviewPage() {
  const splitQuestion = (text) => {
    if (!text) return { intro: "", points: [] };

    // match all numbered points (1) 2. 3)
    const regex = /(\d+[\.\)]\s*)([^]+?)(?=\d+[\.\)]|$)/g;

    const matches = [...text.matchAll(regex)];

    if (matches.length > 0) {
      const firstIndex = matches[0].index;

      const intro = text.slice(0, firstIndex).trim();

      const points = matches
        .map((m) => m[2].trim())
        .filter((p) => p && p.length > 2 && p !== ".");

      return { intro, points };
    }

    // fallback (no numbering)
    return { intro: text, points: [] };
  };

  const navigate = useNavigate();
  // const params = useParams();

const [userId, setUserId] = useState(null);

useEffect(() => {
  const storedUserId = localStorage.getItem("userId");
  setUserId(storedUserId);
}, []);

  // 🔥 MAIN FIX
  // const {testName} = useParams()
  const params = useParams();

  const testName = params.testName;

  const isReasoningTest = testName?.includes("REASONING_TEST"); // ✅ ab safe
  useEffect(() => {
    if (testName) return; // ✅ if already present, do nothing

    const fallback =
      localStorage.getItem("reportTestName") ||
      localStorage.getItem(`testName_${userId}`);

    if (fallback) {
      navigate(`/review/${fallback}`, { replace: true });
    } else {
      console.error("No testName found anywhere");
    }
  }, [testName, navigate, userId]);
  //localStorage.getItem(`testName_${userId}`) || params.testName;
  const topRef = useRef(null);

  const [data, setData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [testDate, setTestDate] = useState("");

  const formatTestDate = (testName) => {
    if (!testName) return "No Date";

    const parts = testName.split("_");

    // ✅ CASE 1: YYYYMMDD (old tests)
    const compactDate = parts.find((p) => /^\d{8}$/.test(p));

    if (compactDate) {
      const year = compactDate.substring(0, 4);
      const month = compactDate.substring(4, 6);
      const day = compactDate.substring(6, 8);

      const d = new Date(`${year}-${month}-${day}`);

      return d.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }

    // ✅ CASE 2: YYYY-MM-DD (reasoning test)
    const dashedDate = parts.find((p) => /^\d{4}-\d{2}-\d{2}$/.test(p));

    if (dashedDate) {
      const d = new Date(dashedDate);

      return d.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }

    return "Invalid Date";
  };

  // 🔥 THEN use it
  useEffect(() => {
    setTestDate(formatTestDate(testName));
    /*
    const tname = localStorage.getItem("reportTestName");
    setTestDate(formatTestDate(tname));
  */
  }, [testName]);

  useEffect(() => {
    // reset everything when test changes
    setData([]);
    setCurrentIndex(0);
    setLoading(true);
  }, [testName]);
  /*
    useEffect(() => {
      if (testName) fetchReview();
    }, [testName]);
  */

  // useEffect(() => {
  //   if (!testName) return;

  //   let interval;
  //   let isActive = true;

  //   //function to start polling
  //   const startPolling = async () => {
  //     await fetchReview(testName);

  //     //starting the interval ---> 3 mins
  //     interval = setInterval(async () => {
  //       if (!isActive) return;
  //       const res = await axiosClient.get("/auth/review-report", {
  //         params: { testName },
  //       });

  //       const list = Array.isArray(res.data?.data) ? res.data.data : [];
  //       if (!isActive) return;
  //       setData(list);

  //       //for checking that is there any correct answer is there
  //       const hasCorrectAnswer = list.some(
  //         //for checking both null ,undefined and also a values
  //         (item) => item.correctAnswer && item.correctAnswer !== "",
  //       );

  //       if (hasCorrectAnswer) {
  //         console.log("correct ans recieved -->stopping polling");
  //         clearInterval(interval);
  //       } else {
  //         console.log("still waiting for correct ans");
  //       }
  //     }, 30000);
  //   };

  //   startPolling();

  //   //when we dont get the correct ans from backend
  //   return () => {
  //     isActive = false;
  //     if (interval) clearInterval(interval);
  //   };
  // }, [testName]);

  useEffect(() => {
    if (!testName) return;

    let interval = null;
    let isActive = true;
    let isPolling = false;

    const pollReview = async () => {
      // Prevent overlapping requests
      if (!isActive || isPolling) return;

      isPolling = true;

      try {
        const res = await axiosClient.get("/auth/review-report", {
          params: { testName },
        });

        const list = Array.isArray(res.data?.data) ? res.data.data : [];

        if (!isActive) return;

        setData(list);
        setCurrentIndex(0);
        setError("");
        setLoading(false);

        // Only coding questions require AI deep analysis
        const codingQuestions = list.filter((item) => item.format === "CODING");

        // Do not stop while no coding questions have been returned
        const allCodingAnalysisComplete =
          codingQuestions.length > 0 &&
          codingQuestions.every(
            (item) =>
              item.deepAnalysis != null &&
              item.correctAnswer != null &&
              String(item.correctAnswer).trim() !== "",
          );

        if (allCodingAnalysisComplete) {
          console.log("All coding analyses received — stopping polling");

          if (interval) {
            clearInterval(interval);
            interval = null;
          }
        } else {
          console.log("Coding analysis still pending — continuing polling");
        }
      } catch (err) {
        console.error("Review polling failed:", err);

        if (isActive) {
          setError(
            err?.response?.data?.message || "Failed to load review data",
          );
          setLoading(false);
        }
      } finally {
        isPolling = false;
      }
    };

    // Fetch immediately, then every 30 seconds
    pollReview();

    interval = setInterval(pollReview, 30000);

    return () => {
      isActive = false;

      if (interval) {
        clearInterval(interval);
      }
    };
  }, [testName]);

  // const fetchReview = async (name) => {
  //   try {
  //     setLoading(true);

  //     const res = await axiosClient.get("/auth/review-report", {
  //       params: { testName: name },
  //     });

  //     const list = Array.isArray(res.data?.data) ? res.data.data : [];

  //     console.log("Review API response:", res.data);
  //     console.table(
  //       list.map((item, index) => ({
  //         index,
  //         questionId: item.questionId,
  //         format: item.format,
  //         topic: item.topic,
  //         userAnswer: item.userAnswer,
  //         hasDeepAnalysis: !!item.deepAnalysis,
  //       })),
  //     );

  //     setData(list);
  //     setCurrentIndex(0);
  //   } catch (err) {
  //     console.error("API ERROR:", err.response || err);
  //     setError(
  //       err?.response?.data?.message || "API Failed to load review data",
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchReview = async (name, showLoader = true) => {
    try {
      if (showLoader) {
        setLoading(true);
      }

      const res = await axiosClient.get("/auth/review-report", {
        params: { testName: name },
      });

      const list = Array.isArray(res.data?.data) ? res.data.data : [];

      console.log("Review API response:", res.data);

      setData(list);

      console.table(
        list.map((item, index) => ({
          index,
          questionId: item.questionId,
          format: item.format,
          correctAnswerAvailable: Boolean(item.correctAnswer),
          deepAnalysisAvailable: Boolean(item.deepAnalysis),
        })),
      );
    } catch (err) {
      console.error("API ERROR:", err.response || err);

      if (showLoader) {
        setError(
          err?.response?.data?.message || "API Failed to load review data",
        );
      }
    } finally {
      if (showLoader) {
        setLoading(false);
      }
    }
  };

  if (loading) return <h2 style={styles.center}>Loading...</h2>;
  if (!data.length) return <h2 style={styles.center}>No Data Found</h2>;

  const item = data[currentIndex];
  const isCoding =
    item.format === "CODING" ||
    item.deepAnalysis != null ||
    (typeof item.userAnswer === "string" && item.userAnswer.includes("\n"));

  const { intro, points } = splitQuestion(item.questionText);

  // let correct = item.correctAnswer;
  // let userAns = item.userAnswer;

  // if (correct?.startsWith("option")) {
  //   correct = correct.replace("option", "");
  // }

  // if (userAns?.startsWith("option")) {
  //   userAns = userAns.replace("option", "");
  // }

  // const isActuallyCorrect = correct === userAns;

  let correct = item.correctAnswer;
  let userAns = item.userAnswer;

  if (correct?.startsWith("option")) {
    correct = correct.replace("option", "");
  }

  if (userAns?.startsWith("option")) {
    userAns = userAns.replace("option", "");
  }

  // ✅ backend value use karo
  const isActuallyCorrect = item.isCorrect;

  // ✅ agar backend ne correctAnswer nahi bheja
  const showStatus =
    item.correctAnswer !== null &&
    item.correctAnswer !== undefined &&
    item.correctAnswer !== "";

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <div
        style={{
          marginTop: "10px",
          fontSize: "14px",
          opacity: 0.95,
          background: "rgba(255,255,255,0.2)",
          padding: "6px 12px",
          borderRadius: "8px",
          display: "inline-block",
        }}
      >
        📅 Attempted on : {testDate}
      </div>

      <div ref={topRef} style={styles.headerBar}>
        <div>
          <h1 style={styles.heading}>Assessment Review</h1>

          <div style={styles.progress}>
            Question {currentIndex + 1} / {data.length}
          </div>
        </div>

        <div style={styles.headerActions}>
          <button
            style={{ ...styles.headerBtn, background: "#0ea5e9" }}
            onClick={() => navigate("/front")}
          >
            Dashboard
          </button>

          <button
            disabled={currentIndex === 0}
            style={styles.headerBtn}
            onClick={() => setCurrentIndex((p) => p - 1)}
          >
            Previous
          </button>

          <button
            disabled={currentIndex === data.length - 1}
            style={styles.headerBtn}
            onClick={() => setCurrentIndex((p) => p + 1)}
          >
            Next
          </button>

          {!isReasoningTest && (
            <button
              style={{ ...styles.headerBtn, background: "#16a34a" }}
              onClick={() => {
                localStorage.setItem("reportTestName", testName);

                const uid = localStorage.getItem("userId");

                if (!uid || uid === "undefined") {
                  alert("UserId missing, please login again");
                  return;
                }

                navigate("/report");
              }}
            >
              Report
            </button>
          )}
        </div>
      </div>

      {/* QUESTION CARD */}

      <div style={styles.card}>
        <h3 style={styles.question}>Q{currentIndex + 1}.</h3>

        {/* ✅ Normal text (before 1) */}
        <div style={{ marginBottom: 10 }}>{intro}</div>

        {/* ✅ Numbered points */}
        {points.length > 0 && (
          <div style={{ marginTop: 10 }}>
            {points.map((p, i) => (
              <div key={i} style={{ marginBottom: 6 }}>
                <b>{i + 1}.</b> {p}
              </div>
            ))}
          </div>
        )}
        <br></br>
        {/* STATUS */}
        {/* <div style={{ marginBottom: 10, display: "flex" }}>
          <Status value={isActuallyCorrect} />
        </div> */}

        {showStatus && (
          <div style={{ marginBottom: 10, display: "flex" }}>
            <Status value={isActuallyCorrect} />
          </div>
        )}

        {/* BADGES */}
        <div style={styles.badgeRow}>
          {item.format && (
            <Badge text={`FORMAT : ${item.format.toUpperCase()}`} />
          )}

          {item.difficulty && (
            <Badge
              text={`DIFFICULTY : ${item.difficulty.toUpperCase()}`}
              type="secondary"
            />
          )}

          {item.accuracyBand && (
            <Badge
              text={`ACCURACYBAND : ${item.accuracyBand.toUpperCase()}`}
              type="success"
            />
          )}

          {item.skillSignal && (
            <Badge
              text={`SKILLSIGNAL : ${item.skillSignal.toUpperCase()}`}
              type="info"
            />
          )}

          {item.studentAction && (
            <Badge
              text={`STUDENTACTION : ${item.studentAction.toUpperCase()}`}
              type="warning"
            />
          )}

          {item.accuracyPercentage !== null && (
            <Badge
              text={`ACCURACYPERCENTAGE : ${item.accuracyPercentage}%`}
              type="primary"
            />
          )}
        </div>

        {/* TOPIC */}
        {item.topic && (
          <div style={styles.infoBox}>
            📚 <b>Topic:</b> {item.topic}
          </div>
        )}

        {/* MCQ */}
        {item.format === "MCQ" && (
          <div style={{ marginTop: 20 }}>
            {["A", "B", "C", "D"].map((letter) => {
              const option = item.options?.[letter];
              if (!option) return null;

              // const isUser = item.userAnswer === letter;
              // const isCorrect = item.correctAnswer === letter;

              let correct = item.correctAnswer;
              let userAns = item.userAnswer;

              if (correct?.startsWith("option")) {
                correct = correct.replace("option", "");
              }

              if (userAns?.startsWith("option")) {
                userAns = userAns.replace("option", "");
              }

              const isActuallyCorrect = correct === userAns;
              const isUser = userAns === letter;

              return (
                <div
                  key={letter}
                  style={{
                    padding: "12px",
                    borderRadius: "8px",
                    marginBottom: "10px",
                    border: "1px solid #ddd",
                    background:
                      correct === letter
                        ? "#dcfce7"
                        : isUser
                          ? "#fee2e2"
                          : "#fff",
                  }}
                >
                  <b>{letter}.</b> {option}
                  {isActuallyCorrect && ""}
                  {isUser && !isActuallyCorrect}
                </div>
              );
            })}
          </div>
        )}

        {/* ANSWERS */}
        {/* <Block title="Your Answer">
          {item.userAnswer
            ? isCoding
              ? item.userAnswer
              : `${item.userAnswer}. ${item.options?.[item.userAnswer]}`
            : "Not Attempted"}
        </Block> */}

        <Block title="Your Answer">
          {item.userAnswer != null && String(item.userAnswer).trim() !== ""
            ? isCoding
              ? String(item.userAnswer)
              : `${item.userAnswer}. ${item.options?.[item.userAnswer] || ""}`
            : "Not Attempted"}
        </Block>

        <Block title="Correct Answer">
          {item.format === "MCQ"
            ? item.correctAnswer
              ? (() => {
                  let ans = item.correctAnswer;

                  // 🔥 FIX → optionA → A
                  if (ans.startsWith("option")) {
                    ans = ans.replace("option", "");
                  }

                  return `${ans}. ${item.options?.[ans] || ""}`;
                })()
              : "Not Provided"
            : item.correctAnswer || "Not Provided"}
        </Block>

        {item.mcqExplanation && (
          <Block title="Explanation">{item.mcqExplanation}</Block>
        )}

        {/* CODING */}
        {isCoding && (
          <>
            {item.aiFeedback && (
              <Block title=" Feedback">{item.aiFeedback}</Block>
            )}

            {item.deepAnalysis?.logics && (
              <Block title="Code Analysis">
                Syntax Errors: {item.deepAnalysis.logics.syntaxErrorPercent}%
                {"\n"}
                Runtime Errors: {item.deepAnalysis.logics.runtimeErrorPercent}%
                {"\n"}
                Logic Errors: {item.deepAnalysis.logics.logicErrorPercent}%
              </Block>
            )}

            {item.deepAnalysis?.bestLogic &&
              Object.keys(item.deepAnalysis.bestLogic).length > 0 && (
                <>
                  {/* <Block title="Best Logic Summary">
                  {item.deepAnalysis.bestLogic.architectureSummary}
                </Block> */}

                  <Block title="Your Logic Steps">
                    {item.deepAnalysis.userLogic.steps?.join("\n")}
                  </Block>

                  <Block title="Best Logic Steps">
                    {item.deepAnalysis.bestLogic.steps?.join("\n")}
                  </Block>

                  <Block title="Best Logic Category">
                    {item.deepAnalysis.bestLogic.category}
                  </Block>
                </>
              )}

            {item.deepAnalysis?.bestLogic?.approach && (
              <Block title="Best Approach">
                {item.deepAnalysis.bestLogic.approach}
              </Block>
            )}

            {item.deepAnalysis?.userLogic && (
              <>
                <Block title="Your Logic Summary">
                  {item.deepAnalysis.userLogic.architectureSummary}
                </Block>

                <Block title="Your Logic Steps">
                  {item.deepAnalysis.userLogic.steps?.join("\n")}
                </Block>

                <Block title="Your Logic Category">
                  {item.deepAnalysis.userLogic.category}
                </Block>
              </>
            )}

            {/* ⭐ LOGIC COMPARISON */}

            {item.deepAnalysis?.logicComparison && (
              <Block title="Logic Comparison">
                Logic Similarity:{" "}
                {item.deepAnalysis.logicComparison.logicSimilarityPercentage}%
                {"\n"}
                Logic Difference:{" "}
                {item.deepAnalysis.logicComparison.logicDifferencePercentage}%
              </Block>
            )}

            {item.deepAnalysis?.studentAction?.recommendedDrill && (
              <Block title="Recommended Practice">
                {item.deepAnalysis.studentAction.recommendedDrill}
              </Block>
            )}

            {item.deepAnalysis?.behavioralCorrelation && (
              <>
                <Block title="Stamina Impact">
                  {item.deepAnalysis.behavioralCorrelation.staminaImpact}
                </Block>

                {item.deepAnalysis?.behavioralCorrelation?.logicFrictionPoints
                  ?.length > 0 && (
                  <Block title="Logic Friction Points">
                    {item.deepAnalysis.behavioralCorrelation.logicFrictionPoints
                      .map((p) =>
                        typeof p === "string"
                          ? p
                          : `${p.type || ""} (${p.count || ""})`,
                      )
                      .join("\n")}
                  </Block>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

/* COMPONENTS */

const Status = ({ value }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      padding: "4px 10px", // smaller padding
      borderRadius: "14px", // same as badges
      fontSize: "12px", // same size as badges
      fontWeight: "600",
      background: value ? "#dcfce7" : "#fee2e2",
      color: value ? "#166534" : "#991b1b",
    }}
  >
    {value ? "Correct" : "Wrong"}
  </span>
);

const Badge = ({ text, type }) => {
  const colors = {
    secondary: { bg: "#e0f2fe", color: "#0369a1" },
    success: { bg: "#dcfce7", color: "#166534" },
    warning: { bg: "#fef3c7", color: "#92400e" },
    info: { bg: "#ede9fe", color: "#5b21b6" },
    primary: { bg: "#cffafe", color: "#155e75" },
    default: { bg: "#ede9fe", color: "#5b21b6" },
  };

  const style = colors[type] || colors.default;

  return (
    <span
      style={{
        padding: "5px 10px",
        borderRadius: "14px",
        fontSize: "12px",
        marginRight: "6px",
        background: style.bg,
        color: style.color,
        fontWeight: "600",
      }}
    >
      {text}
    </span>
  );
};

const Block = ({ title, children }) => {
  // ❌ agar data empty hai → show hi mat karo
  if (
    !children ||
    children.toString().trim() === "" ||
    children === "No Attempt" ||
    children === "User did not provide any solution."
  ) {
    return null;
  }

  return (
    <div style={{ marginTop: 20 }}>
      <div style={{ fontWeight: "600", marginBottom: 6 }}>{title}</div>

      <pre
        style={{
          background: "#0f172a",
          color: "#22c55e",
          padding: "12px",
          borderRadius: "8px",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          overflowWrap: "break-word",
          maxWidth: "100%",
          overflowX: "auto",
          maxHeight: "350px",
          overflowY: "auto",
        }}
      >
        {children}
      </pre>
    </div>
  );
};
